<template>
  <AggreementContent title="СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ">
Я даю согласие Акционерному обществу «ГК ОСНОВА», зарегистрированного по адресу: АО «ГК ОСНОВА», зарегистрированный по адресу 142700, Московская область, г.о. Ленинский, г. Видное, ш. Белокаменное, д. 20 (далее -  Оператор) на обработку своих персональных данных на следующих условиях:<br>
Цели обработки Персональных данных:  <br>
    • идентификация, создания учетной записи;<br>
    • проведение Оператором маркетинговых исследований, опросов по качеству обслуживания, прочих опросов;<br>
    • организация стимулирующих мероприятий (акции, конкурсы и пр.) и программы лояльности Оператора;<br>
    • анализ информации, хранимой в файлах cookies;<br>
    • совершенствование и развитие деятельности Оператора;<br>
    • оказание информационных, справочных и консультационных услуг в рамках телефонного обслуживания;<br>
    • обработку, рассмотрение поступающих обращений, предоставление эффективной поддержки при возникновении проблем.<br>
Перечень обрабатываемых персональных данных: <br>
    • фамилия, имя, отчество;<br>
    • контактные данные (номер телефона, адрес электронной почты, псевдоним (идентификатор) в социальных сетях и сервисах коммуникаций);<br>
    • электронные пользовательские данные (файлы cookies).<br>
Действия с персональными данными: автоматизированная и неавтоматизированная (смешанная) обработка посредством осуществления следующих действий: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, передача (предоставление, доступ), блокирование, удаление, уничтожение.<br>
Сроки обработки персональных данных: с момента предоставления настоящего согласия до достижения целей обработки или до отзыва согласия. <br>
Порядок отзыва: настоящее Согласие может быть отозвано мной в любой момент времени, путем направления письменного запроса в адрес Оператора или на электронную почту: <a href="mail:dpers@gk-osnova.ru">dpers@gk-osnova.ru</a>.<br>
Настоящее согласие имеет юридическую силу, считаетсяe заполненным и является подписанным с момента заполнения формы путем принятия условий и проставления графического элемента согласия («галочки» в соответствующем чек-боксе), являющегося заменой собственноручной подписи.<br>
Политика обработки персональных данных расположена по адресу: <a target="_blank" href="/agreement.pdf">https://kedo.gk-osnova.ru/agreement.pdf</a>.
  </AggreementContent>
</template>

<script>
import AggreementContent from '@/components/AggreementContent.vue'

export default {
  components: {
    AggreementContent
  }
}
</script>
